import React, { useState } from 'react';
import './NewHomepage.css';
import logo200h from '../assets/logo-200h.png';
import logo2200h from '../assets/logo2-200h.png';
import aiResumeMakerLogo from '../assets/logo-airesumemaker.png';
import nycSchoolsLogo from '../assets/logo-nycschools.png';
import tinyTellersLogo from '../assets/logo-tinytellers.png';

const NewHomepage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="new-homepage">
      <header className="header">
        <div className="container">
          <div className="nav">
            <div className="logo">
              <h1>EssentialX</h1>
            </div>
            <nav className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
              <a href="https://consulting.essentialx.us" className="nav-link" onClick={toggleMenu}>Services</a>
              <a href="#products" className="nav-link" onClick={toggleMenu}>Products</a>
              <a href="mailto:contact@essentialx.us" className="nav-link" onClick={toggleMenu}>Contact</a>
            </nav>
            <div className="menu-icon" onClick={toggleMenu}>
              <div className="bar"></div>
              <div className="bar"></div>
              <div className="bar"></div>
            </div>
          </div>
        </div>
      </header>

      <main className="main">
        <section id="products" className="products">
          <div className="container">
            <h2 className="category-heading">AI</h2>
            <div className="products-grid">
              <div className="product-card double-card">
                <div className="double-card-content">
                  <div className="sub-product">
                    <div className="product-icon">
                      <img src={aiResumeMakerLogo} alt="AI Resume Maker" />
                    </div>
                    <h3 className="product-title">AI Resume Maker</h3>
                    <p className="product-description">
                      An AI-powered platform to build, edit, and optimize professional resumes and cover letters.  Tailor your entire application to specific job descriptions to increase your chances of getting hired.
                    </p>
                    <a href="https://ai.resume.essentialx.us/" className="product-link">
                      Web App →
                    </a>
                  </div>

                  <div className="plus-sign">+</div>

                  <div className="sub-product">
                    <div className="product-icon">
                      <img src={aiResumeMakerLogo} alt="Extension" />
                    </div>
                    <h3 className="product-title">Extension</h3>
                    <p className="product-description">
                      Brings AI Resume Maker's power directly to your browser for faster job applications.
                    </p>
                    <a href="https://chromewebstore.google.com/detail/ai-resumemaker-job-apply/pladepfjgbdfedagfnecnphppmikhehi" className="product-link">
                      Install Extension →
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <h2 className="category-heading">Finance</h2>
            <div className="products-grid">
              <div className="product-card">
                <div className="product-icon">
                  <div style={{
                    backgroundColor: '#3b82f6',
                    width: '64px',
                    height: '64px',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto',
                    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.2)'
                  }}>
                    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>
                    </svg>
                  </div>
                </div>
                <h3 className="product-title">
                  <span style={{ color: '#60a5fa' }}>Future</span>Path
                </h3>
                <p className="product-description">
                  An intelligent financial planning tool to help you visualize your path to retirement, specifically focusing on the transition through semi-retirement.
                </p>
                <a href="http://futurepath.essentialx.us/" className="product-link">
                  Learn More →
                </a>
              </div>
            </div>

            <h2 className="category-heading">Learning</h2>
            <div className="products-grid">
              <div className="product-card">
                <div className="product-icon">
                  <img
                    src="https://is1-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/66/69/16/66691638-cc5d-aa98-e913-8f29eab41ace/Placeholder.mill/400x400bb-75.jpg"
                    alt="TinyMinds"
                    style={{ borderRadius: '16px' }}
                  />
                </div>
                <h3 className="product-title">TinyMinds</h3>
                <p className="product-description">
                  A Montessori-inspired milestone tracking app for parents of children aged 0 to 6. Track developmental progress across 8 key areas and receive personalized activity recommendations.
                </p>
                <a href="https://tinyminds.essentialx.us" className="product-link">
                  Learn More →
                </a>
              </div>

              <div className="product-card">
                <div className="product-icon">
                  <img
                    src="https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/31/a6/1b/31a61b5b-ce6c-3bcd-1505-fa2bbeb0c020/AppIcon-0-0-1x_U007ephone-0-1-85-220.png/512x512bb.jpg"
                    alt="TinyTales"
                    style={{ borderRadius: '16px' }}
                  />
                </div>
                <h3 className="product-title">TinyTales</h3>
                <p className="product-description">
                  Smart book recommendations for your child — tailored not just by age, but by developmental stage. Semantic search helps you find the perfect book by meaning, not just keywords. Scan any book's barcode to instantly see if it's the right fit.
                </p>
                <a href="https://tinytales.essentialx.us" className="product-link">
                  Learn More →
                </a>
              </div>

              <div className="product-card">
                <div className="product-icon">
                  <img
                    src="https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/bc/ae/0c/bcae0ce4-6fa9-b917-effa-8858e01e139e/AppIcon-0-0-1x_U007ephone-0-1-85-220.png/512x512bb.jpg"
                    alt="TinyFeelings"
                    style={{ borderRadius: '16px' }}
                  />
                </div>
                <h3 className="product-title">TinyFeelings</h3>
                <p className="product-description">
                  Emotional growth tracking that meets your child at their real social-emotional stage. Built on the same 5-skill CASEL framework schools use, it recommends activities, toys, and books matched to exactly where they are right now.
                </p>
                <a href="https://tinyfeelings.essentialx.us" className="product-link">
                  Learn More →
                </a>
              </div>

              <div className="product-card center-last">
                <div className="product-icon">
                  <img src={tinyTellersLogo} alt="Tiny Tellers" style={{ borderRadius: '16px' }} />
                </div>
                <h3 className="product-title">Tiny Tellers</h3>
                <p className="product-description">
                  Keep the stories your child tells and turn them into illustrated picture books. Pictures are made on your iPhone with Apple Intelligence, and stories stay in your own iCloud.
                </p>
                <a href="https://tinytellers.essentialx.us/" className="product-link">
                  Learn More →
                </a>
              </div>
            </div>

            <h2 className="category-heading">Education</h2>
            <div className="products-grid">
              <div className="product-card double-card">
                <div className="double-card-content">
                  <div className="sub-product">
                    <div className="product-icon">
                      <img src={nycSchoolsLogo} alt="NYC Schools" style={{ borderRadius: '16px' }} />
                    </div>
                    <h3 className="product-title">NYC Schools</h3>
                    <p className="product-description">
                      Admissions odds, quality data, and zoning for every New York City public school.
                    </p>
                    <a href="https://nycschools.essentialx.us/" className="product-link">
                      Web App →
                    </a>
                  </div>

                  <div className="plus-sign">+</div>

                  <div className="sub-product">
                    <div className="product-icon">
                      <img src={nycSchoolsLogo} alt="NYC Schools Guide iOS App" style={{ borderRadius: '16px' }} />
                    </div>
                    <h3 className="product-title">iOS App</h3>
                    <p className="product-description">
                      NYC Schools Guide brings zoning, quality, and admissions data to your iPhone, with saved schools and comparisons synced to your account.
                    </p>
                    <a href="https://apps.apple.com/us/app/nyc-schools-guide/id6793120112" className="product-link">
                      App Store →
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <h2 className="category-heading">Extensions &amp; Tools</h2>
            <div className="products-grid extensions-grid">
              <div className="product-card">
                <div className="product-icon">
                  <img src={logo200h} alt="Website Tracker" />
                </div>
                <h3 className="product-title">Website Tracker</h3>
                <p className="product-description">
                  Chrome extension that monitors website changes and sends notifications, with AI-powered smart tracking capabilities.
                </p>
                <a href="https://websitetracker.essentialx.us" className="product-link">
                  Learn More →
                </a>
              </div>

              <div className="product-card">
                <div className="product-icon">
                  <img src={logo2200h} alt="ResBooker" />
                </div>
                <h3 className="product-title">ResBooker</h3>
                <p className="product-description">
                  Chrome extension for automated restaurant reservation booking
                </p>
                <a href="https://resbooker.essentialx.us" className="product-link">
                  Learn More →
                </a>
              </div>

              <div className="product-card">
                <div className="product-icon">
                  <h2 style={{ fontSize: '3em' }}>🛒</h2>
                </div>
                <h3 className="product-title">AI Shopping Cart</h3>
                <p className="product-description">
                  Our Shopping Assistant Agent helps you find the best prices and options for your shopping list items across various e-commerce websites. Simply add items to your cart, and our AI agent will do the research for you!
                </p>
                <a href="https://shopping.agent.essentialx.us/" className="product-link">
                  Learn More →
                </a>
              </div>

              <div className="product-card center-last">
                <div className="product-icon">
                  <h2>WCalc</h2>
                </div>
                <h3 className="product-title">Withholding Calculator</h3>
                <p className="product-description">
                  A tool to calculate tax withholdings (W4) for families.
                </p>
                <a href="https://withholdingcalculator.essentialx.us" className="product-link">
                  Learn More →
                </a>
              </div>
            </div>

            <h2 className="category-heading">Services</h2>
            <div className="products-grid">
              <div className="product-card">
                <div className="product-icon">
                  <h2 style={{ fontSize: '3em' }}>💬</h2>
                </div>
                <h3 className="product-title">Talk to us</h3>
                <p className="product-description">
                  Have a project in mind or need expert advice? Reach out to us for a consultation.
                </p>
                <a href="https://consulting.essentialx.us/" className="product-link">
                  Learn More →
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container">
          <p>&copy; 2026 Essential X, All Rights Reserved. | <a href="https://www.linkedin.com/company/essentialx/" target="_blank" rel="noopener noreferrer">Our LinkedIn</a></p>
        </div>
      </footer>
    </div>
  );
};

export default NewHomepage;
